import deriveProductFromProductSku from './deriveProductFromProductSku.js';
import productModalConfig from './triggerTopPageAuthenticationFlow.config.json';

function triggerTopPageAuthenticationFlow(props) {
  const {
    href: hrefProp,
    productSku,
    product: productProp,
    modalType,
    contentType,
    offerGroup,
    analyticFlowPrefix,
  } = props;

  const product = productSku
    ? deriveProductFromProductSku(productSku)
    : productProp;

  const {
    [modalType]: {
      trigger,
      analyticFlow: { [contentType]: analyticFlowDefault },
    },
  } = productModalConfig[product];

  // Cross sell scenarios we want to prefix the analytic flow with the primary product
  // For example, if the primary product is Plus and the cross sell product is Pro, the analytic flow would be plus-pro-*
  const analyticFlow = analyticFlowPrefix
    ? `${analyticFlowPrefix}-${analyticFlowDefault}`
    : analyticFlowDefault;

  const params = {
    trigger,
    analyticFlow,
  };
  if (offerGroup) {
    params.offerGroup = offerGroup;
  }
  const urlSearchParams = new URLSearchParams(params);

  const url = new URL(hrefProp);
  urlSearchParams.forEach((value, key) => {
    url.searchParams.append(key, value);
  });

  const { href } = url;

  const event = new CustomEvent('onzephrhistoryreplace', {
    detail: { href },
  });

  window.dispatchEvent(event);
}

export default triggerTopPageAuthenticationFlow;
